// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../../stores/mobx-compat";

import { TablePager } from '../../../../ui/Table';

class TypeformPagination extends Component {
  typeform = this.props.store.integrations.Typeform;

  render() {
    const totalPages = this.typeform.formData.page_count || 0;
    if (totalPages <= 1) return null;
    return (
      <div className="mt-4 flex justify-center">
        <TablePager
          page={this.typeform.activePage}
          totalPages={totalPages}
          onChange={(p) => this.typeform.updateActivePage(p)}
        />
      </div>
    );
  }
}

export default inject('store')(observer(TypeformPagination));
